// import saga helpers
import { call, put, all, takeEvery } from "redux-saga/effects";

import {
  SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST,
  CREATE_OPPORTUNITIES_ITEM,
  UPDATE_OPPORTUNITIES_ITEM,
  GET_ALL_OPPORTUNITIES_LIST,
  GET_SINGLE_OPPORTUNITIES_ITEM,
  DELETE_OPPORTUNITIES_ITEM,
  OPPORTUNITIES_STATUS_LIST,
  OPPORTUNITIES_PRIORITY_LIST,
  OPPORTUNITIES_TYPE_LIST,
  GET_SINGLE_OPPORTUNITY_DATA,
  SEARCH_OPPORTUNITY_NOTE_LIST,
  CREATE_OPPORTUNITY_NOTE_ITEM,
  SINGLE_OPPORTUNITY_ACTIVITY_LIST,
  ADD_NEW_OPPORTUNITY_STATUS,
  DELETE_OPPORTUNITY_STATUS,
  UPDATE_OPPORTUNITY_STATUS,
  ADD_NEW_OPPORTUNITY_PRIORITY,
  DELETE_OPPORTUNITY_PRIORITY,
  UPDATE_OPPORTUNITY_PRIORITY,
  ADD_NEW_OPPORTUNITY_TYPE,
  DELETE_OPPORTUNITY_TYPE,
  UPDATE_OPPORTUNITY_TYPE,
  GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA,
  SEARCH_OPPORTUNITY_ATTACHMENT_LIST,
  DELETE_OPPORTUNITY_ATTACHMENT,
  SEARCH_OPPORTUNITY_PRODUCT_LIST,
  CREATE_OPPORTUNITY_PRODUCT_ITEM,
  DELETE_OPPORTUNITY_PRODUCT_ITEM,
} from "./actionType";

//import Action
import {
  searchSingleCustomerOpportunitiesListSuccess,
  searchSingleCustomerOpportunitiesListFail,
  createOpportunitiesItemSuccess,
  createOpportunitiesItemFail,
  updateOpportunitiesItemSuccess,
  updateOpportunitiesItemFail,
  getAllOpportunitiesListSuccess,
  getAllOpportunitiesListFail,
  getSingleOpportunitiesItemSuccess,
  getSingleOpportunitiesItemFail,
  deleteOpportunitiesItemSuccess,
  deleteOpportunitiesItemFail,
  opportunitiesStatusListSuccess,
  opportunitiesStatusListFail,
  opportunitiesPriorityListSuccess,
  opportunitiesPriorityListFail,
  opportunitiesTypeListSuccess,
  opportunitiesTypeListFail,
  getSingleOpportunityDataSuccess,
  getSingleOpportunityDataFail,
  searchOpportunityNoteListSuccess,
  searchOpportunityNoteListFail,
  createOpportunityNoteItemSuccess,
  createOpportunityNoteItemFail,
  singleOpportunityActivityListSuccess,
  singleOpportunityActivityListFail,
  addNewOpportunityStatusSuccess,
  addNewOpportunityStatusFail,
  deleteOpportunityStatusSuccess,
  deleteOpportunityStatusFail,
  updateOpportunityStatusSuccess,
  updateOpportunityStatusFail,
  addNewOpportunityPrioritySuccess,
  addNewOpportunityPriorityFail,
  deleteOpportunityPrioritySuccess,
  deleteOpportunityPriorityFail,
  updateOpportunityPrioritySuccess,
  updateOpportunityPriorityFail,
  addNewOpportunityTypeSuccess,
  addNewOpportunityTypeFail,
  deleteOpportunityTypeSuccess,
  deleteOpportunityTypeFail,
  updateOpportunityTypeSuccess,
  updateOpportunityTypeFail,
  getOpportunityOverviewFunnelDataSuccess,
  getOpportunityOverviewFunnelDataFail,
  searchOpportunityAttachmentListSuccess,
  searchOpportunityAttachmentListFail,
  deleteOpportunityAttachmentSuccess,
  deleteOpportunityAttachmentFail,
  searchOpportunityProductListSuccess,
  searchOpportunityProductListFail,
  createOpportunityProductItemSuccess,
  createOpportunityProductItemFail,
  deleteOpportunityProductItemSuccess,
  deleteOpportunityProductItemFail,
} from "./action";

import {
  createNewOpportunityItemApiCall,
  searchSingleCustomerOpportunityListApiCall,
  updateOpportunityItemApiCall,
  getOpportunityListApiCall,
  getSingleOpportunityDataApiCall,
  deleteOpportunityItemApiCall,
  getOpportunityStatusListApiCall,
  getOpportunityPriorityListApiCall,
  getOpportunityTypeListApiCall,
  getSingleOpportunityPageDataApiCall,
  searchOpportunityNoteListApiCall,
  createOpportunityNoteItemApiCall,
  singleOpportunityActivityListApiCall,
  addNewOpportunityStatusApiCall,
  deleteOpportunityStatusApiCall,
  updateOpportunityStatusApiCall,
  addNewOpportunityPriorityApiCall,
  deleteOpportunityPriorityApiCall,
  updateOpportunityPriorityApiCall,
  addNewOpportunityTypeApiCall,
  deleteOpportunityTypeApiCall,
  updateOpportunityTypeApiCall,
  getOpportunityOverviewFunnelDataApiCall,
  postSearchOpportunityAttachmentListApiCall,
  postDeleteOpportunityAttachmentApiCall,
  searchOpportunityProductListApiCall,
  createOpportunityProductItemApiCall,
  deleteOpportunityProductItemApiCall,
} from "../../helpers/fakebackend_helper";

// Saga functions for Opportunities

// Search Single Customer Opportunities List
function* searchSingleCustomerOpportunitiesListSaga({ payload }) {
  try {
    const response = yield call(
      searchSingleCustomerOpportunityListApiCall,
      payload
    );
    yield put(searchSingleCustomerOpportunitiesListSuccess(response));
  } catch (error) {
    yield put(searchSingleCustomerOpportunitiesListFail(error));
  }
}

function* watchSearchSingleCustomerOpportunitiesListSaga() {
  yield takeEvery(
    SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST,
    searchSingleCustomerOpportunitiesListSaga
  );
}

// Create Opportunity Item
function* createOpportunitiesItemSaga({ payload }) {
  try {
    const response = yield call(createNewOpportunityItemApiCall, payload);
    yield put(createOpportunitiesItemSuccess(response));
  } catch (error) {
    yield put(createOpportunitiesItemFail(error));
  }
}

function* watchCreateOpportunitiesItemSaga() {
  yield takeEvery(CREATE_OPPORTUNITIES_ITEM, createOpportunitiesItemSaga);
}

// Update Opportunity Item
function* updateOpportunitiesItemSaga({ payload }) {
  try {
    const response = yield call(updateOpportunityItemApiCall, payload);
    yield put(updateOpportunitiesItemSuccess(response));
  } catch (error) {
    yield put(updateOpportunitiesItemFail(error));
  }
}

function* watchUpdateOpportunitiesItemSaga() {
  yield takeEvery(UPDATE_OPPORTUNITIES_ITEM, updateOpportunitiesItemSaga);
}

// Get All Opportunity List
function* getAllOpportunitiesListSaga() {
  try {
    const response = yield call(getOpportunityListApiCall);
    yield put(getAllOpportunitiesListSuccess(response));
  } catch (error) {
    yield put(getAllOpportunitiesListFail(error));
  }
}

function* watchGetAllOpportunitiesListSaga() {
  yield takeEvery(GET_ALL_OPPORTUNITIES_LIST, getAllOpportunitiesListSaga);
}

// Get Single Opportunity Item
function* getSingleOpportunitiesItemSaga({ payload }) {
  try {
    const response = yield call(getSingleOpportunityDataApiCall, payload);
    yield put(getSingleOpportunitiesItemSuccess(response));
  } catch (error) {
    yield put(getSingleOpportunitiesItemFail(error));
  }
}

function* watchGetSingleOpportunitiesItemSaga() {
  yield takeEvery(
    GET_SINGLE_OPPORTUNITIES_ITEM,
    getSingleOpportunitiesItemSaga
  );
}

// Delete Opportunity Item

function* deleteOpportunitiesItemSaga({ payload }) {
  try {
    const response = yield call(deleteOpportunityItemApiCall, payload);
    yield put(deleteOpportunitiesItemSuccess(response));
  } catch (error) {
    yield put(deleteOpportunitiesItemFail(error));
  }
}

function* watchDeleteOpportunitiesItemSaga() {
  yield takeEvery(DELETE_OPPORTUNITIES_ITEM, deleteOpportunitiesItemSaga);
}

// Get Opportunity Status List
function* opportunitiesStatusListSaga() {
  try {
    const response = yield call(getOpportunityStatusListApiCall);
    yield put(opportunitiesStatusListSuccess(response));
  } catch (error) {
    yield put(opportunitiesStatusListFail(error));
  }
}

function* watchOpportunitiesStatusListSaga() {
  yield takeEvery(OPPORTUNITIES_STATUS_LIST, opportunitiesStatusListSaga);
}

// Get Opportunity Priority List
function* opportunitiesPriorityListSaga() {
  try {
    const response = yield call(getOpportunityPriorityListApiCall);
    yield put(opportunitiesPriorityListSuccess(response));
  } catch (error) {
    yield put(opportunitiesPriorityListFail(error));
  }
}

function* watchOpportunitiesPriorityListSaga() {
  yield takeEvery(OPPORTUNITIES_PRIORITY_LIST, opportunitiesPriorityListSaga);
}

// Get Opportunity Type List
function* opportunitiesTypeListSaga() {
  try {
    const response = yield call(getOpportunityTypeListApiCall);
    yield put(opportunitiesTypeListSuccess(response));
  } catch (error) {
    yield put(opportunitiesTypeListFail(error));
  }
}

function* watchOpportunitiesTypeListSaga() {
  yield takeEvery(OPPORTUNITIES_TYPE_LIST, opportunitiesTypeListSaga);
}

// Get Single Opportunity Data
function* getSingleOpportunityDataSaga({ payload }) {
  try {
    const response = yield call(getSingleOpportunityPageDataApiCall, payload);
    yield put(getSingleOpportunityDataSuccess(response));
  } catch (error) {
    yield put(getSingleOpportunityDataFail(error));
  }
}

function* watchGetSingleOpportunityDataSaga() {
  yield takeEvery(GET_SINGLE_OPPORTUNITY_DATA, getSingleOpportunityDataSaga);
}

// Search Opportunity Note List
function* searchOpportunityNoteListSaga({ payload }) {
  try {
    const response = yield call(searchOpportunityNoteListApiCall, payload);
    yield put(searchOpportunityNoteListSuccess(response));
  } catch (error) {
    yield put(searchOpportunityNoteListFail(error));
  }
}

function* watchSearchOpportunityNoteListSaga() {
  yield takeEvery(SEARCH_OPPORTUNITY_NOTE_LIST, searchOpportunityNoteListSaga);
}

// Create Opportunity Note Item

function* createOpportunityNoteItemSaga({ payload }) {
  try {
    const response = yield call(createOpportunityNoteItemApiCall, payload);
    yield put(createOpportunityNoteItemSuccess(response));
  } catch (error) {
    yield put(createOpportunityNoteItemFail(error));
  }
}

// Single Opportunity Activity List
function* singleOpportunityActivityListSaga({ payload }) {
  try {
    const response = yield call(singleOpportunityActivityListApiCall, payload);
    yield put(singleOpportunityActivityListSuccess(response));
  } catch (error) {
    yield put(singleOpportunityActivityListFail(error));
  }
}

function* watchSingleOpportunityActivityListSaga() {
  yield takeEvery(
    SINGLE_OPPORTUNITY_ACTIVITY_LIST,
    singleOpportunityActivityListSaga
  );
}

function* watchCreateOpportunityNoteItemSaga() {
  yield takeEvery(CREATE_OPPORTUNITY_NOTE_ITEM, createOpportunityNoteItemSaga);
}

// Add New Opportunity Status
function* addNewOpportunityStatusSaga({ payload }) {
  try {
    const response = yield call(addNewOpportunityStatusApiCall, payload);
    yield put(addNewOpportunityStatusSuccess(response));
  } catch (error) {
    yield put(addNewOpportunityStatusFail(error));
  }
}

function* watchAddNewOpportunityStatusSaga() {
  yield takeEvery(ADD_NEW_OPPORTUNITY_STATUS, addNewOpportunityStatusSaga);
}

// Delete Opportunity Status
function* deleteOpportunityStatusSaga({ payload }) {
  try {
    const response = yield call(deleteOpportunityStatusApiCall, payload);
    yield put(deleteOpportunityStatusSuccess(response));
  } catch (error) {
    yield put(deleteOpportunityStatusFail(error));
  }
}

function* watchDeleteOpportunityStatusSaga() {
  yield takeEvery(DELETE_OPPORTUNITY_STATUS, deleteOpportunityStatusSaga);
}

// Update Opportunity Status
function* updateOpportunityStatusSaga({ payload }) {
  try {
    const response = yield call(updateOpportunityStatusApiCall, payload);
    yield put(updateOpportunityStatusSuccess(response));
  } catch (error) {
    yield put(updateOpportunityStatusFail(error));
  }
}

function* watchUpdateOpportunityStatusSaga() {
  yield takeEvery(UPDATE_OPPORTUNITY_STATUS, updateOpportunityStatusSaga);
}

// Add New Opportunity Priority
function* addNewOpportunityPrioritySaga({ payload }) {
  try {
    const response = yield call(addNewOpportunityPriorityApiCall, payload);
    yield put(addNewOpportunityPrioritySuccess(response));
  } catch (error) {
    yield put(addNewOpportunityPriorityFail(error));
  }
}

function* watchAddNewOpportunityPrioritySaga() {
  yield takeEvery(ADD_NEW_OPPORTUNITY_PRIORITY, addNewOpportunityPrioritySaga);
}

// Delete Opportunity Priority
function* deleteOpportunityPrioritySaga({ payload }) {
  try {
    const response = yield call(deleteOpportunityPriorityApiCall, payload);
    yield put(deleteOpportunityPrioritySuccess(response));
  } catch (error) {
    yield put(deleteOpportunityPriorityFail(error));
  }
}

function* watchDeleteOpportunityPrioritySaga() {
  yield takeEvery(DELETE_OPPORTUNITY_PRIORITY, deleteOpportunityPrioritySaga);
}

// Update Opportunity Priority
function* updateOpportunityPrioritySaga({ payload }) {
  try {
    const response = yield call(updateOpportunityPriorityApiCall, payload);
    yield put(updateOpportunityPrioritySuccess(response));
  } catch (error) {
    yield put(updateOpportunityPriorityFail(error));
  }
}

function* watchUpdateOpportunityPrioritySaga() {
  yield takeEvery(UPDATE_OPPORTUNITY_PRIORITY, updateOpportunityPrioritySaga);
}

// Add New Opportunity Type
function* addNewOpportunityTypeSaga({ payload }) {
  try {
    const response = yield call(addNewOpportunityTypeApiCall, payload);
    yield put(addNewOpportunityTypeSuccess(response));
  } catch (error) {
    yield put(addNewOpportunityTypeFail(error));
  }
}

function* watchAddNewOpportunityTypeSaga() {
  yield takeEvery(ADD_NEW_OPPORTUNITY_TYPE, addNewOpportunityTypeSaga);
}

// Delete Opportunity Type
function* deleteOpportunityTypeSaga({ payload }) {
  try {
    const response = yield call(deleteOpportunityTypeApiCall, payload);
    yield put(deleteOpportunityTypeSuccess(response));
  } catch (error) {
    yield put(deleteOpportunityTypeFail(error));
  }
}

function* watchDeleteOpportunityTypeSaga() {
  yield takeEvery(DELETE_OPPORTUNITY_TYPE, deleteOpportunityTypeSaga);
}

// Update Opportunity Type
function* updateOpportunityTypeSaga({ payload }) {
  try {
    const response = yield call(updateOpportunityTypeApiCall, payload);
    yield put(updateOpportunityTypeSuccess(response));
  } catch (error) {
    yield put(updateOpportunityTypeFail(error));
  }
}

function* watchUpdateOpportunityTypeSaga() {
  yield takeEvery(UPDATE_OPPORTUNITY_TYPE, updateOpportunityTypeSaga);
}

// Get Opportunity Overview Funnel Data
function* getOpportunityOverviewFunnelDataSaga({ payload }) {
  try {
    const response = yield call(
      getOpportunityOverviewFunnelDataApiCall,
      payload
    );
    yield put(getOpportunityOverviewFunnelDataSuccess(response));
  } catch (error) {
    yield put(getOpportunityOverviewFunnelDataFail(error));
  }
}

function* watchGetOpportunityOverviewFunnelDataSaga() {
  yield takeEvery(
    GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA,
    getOpportunityOverviewFunnelDataSaga
  );
}

// Search Opportunity Attachment List
function* searchOpportunityAttachmentListSaga({ payload }) {
  try {
    const response = yield call(
      postSearchOpportunityAttachmentListApiCall,
      payload
    );
    yield put(searchOpportunityAttachmentListSuccess(response));
  } catch (error) {
    yield put(searchOpportunityAttachmentListFail(error));
  }
}

function* watchSearchOpportunityAttachmentListSaga() {
  yield takeEvery(
    SEARCH_OPPORTUNITY_ATTACHMENT_LIST,
    searchOpportunityAttachmentListSaga
  );
}

// Delete Opportunity Attachment
function* deleteOpportunityAttachmentSaga({ payload }) {
  try {
    const response = yield call(postDeleteOpportunityAttachmentApiCall, payload);
    yield put(deleteOpportunityAttachmentSuccess(response));
  } catch (error) {
    yield put(deleteOpportunityAttachmentFail(error));
  }
}

function* watchDeleteOpportunityAttachmentSaga() {
  yield takeEvery(DELETE_OPPORTUNITY_ATTACHMENT, deleteOpportunityAttachmentSaga);
}

// Search Opportunity Product (interested products) List
function* searchOpportunityProductListSaga({ payload }) {
  try {
    const response = yield call(searchOpportunityProductListApiCall, payload);
    yield put(searchOpportunityProductListSuccess(response));
  } catch (error) {
    yield put(searchOpportunityProductListFail(error));
  }
}

function* watchSearchOpportunityProductListSaga() {
  yield takeEvery(
    SEARCH_OPPORTUNITY_PRODUCT_LIST,
    searchOpportunityProductListSaga
  );
}

// Create Opportunity Product Item
function* createOpportunityProductItemSaga({ payload }) {
  try {
    const response = yield call(createOpportunityProductItemApiCall, payload);
    yield put(createOpportunityProductItemSuccess(response));
  } catch (error) {
    yield put(createOpportunityProductItemFail(error));
  }
}

function* watchCreateOpportunityProductItemSaga() {
  yield takeEvery(
    CREATE_OPPORTUNITY_PRODUCT_ITEM,
    createOpportunityProductItemSaga
  );
}

// Delete Opportunity Product Item
function* deleteOpportunityProductItemSaga({ payload }) {
  try {
    const response = yield call(deleteOpportunityProductItemApiCall, payload);
    yield put(deleteOpportunityProductItemSuccess(response));
  } catch (error) {
    yield put(deleteOpportunityProductItemFail(error));
  }
}

function* watchDeleteOpportunityProductItemSaga() {
  yield takeEvery(
    DELETE_OPPORTUNITY_PRODUCT_ITEM,
    deleteOpportunityProductItemSaga
  );
}

export default function* Opportunities() {
  yield all([
    watchSearchSingleCustomerOpportunitiesListSaga(),
    watchCreateOpportunitiesItemSaga(),
    watchUpdateOpportunitiesItemSaga(),
    watchGetAllOpportunitiesListSaga(),
    watchGetSingleOpportunitiesItemSaga(),
    watchDeleteOpportunitiesItemSaga(),
    watchOpportunitiesStatusListSaga(),
    watchOpportunitiesPriorityListSaga(),
    watchOpportunitiesTypeListSaga(),
    watchGetSingleOpportunityDataSaga(),
    watchSearchOpportunityNoteListSaga(),
    watchCreateOpportunityNoteItemSaga(),
    watchSingleOpportunityActivityListSaga(),
    watchAddNewOpportunityStatusSaga(),
    watchDeleteOpportunityStatusSaga(),
    watchUpdateOpportunityStatusSaga(),
    watchAddNewOpportunityPrioritySaga(),
    watchDeleteOpportunityPrioritySaga(),
    watchUpdateOpportunityPrioritySaga(),
    watchAddNewOpportunityTypeSaga(),
    watchDeleteOpportunityTypeSaga(),
    watchUpdateOpportunityTypeSaga(),
    watchGetOpportunityOverviewFunnelDataSaga(),
    watchSearchOpportunityAttachmentListSaga(),
    watchDeleteOpportunityAttachmentSaga(),
    watchSearchOpportunityProductListSaga(),
    watchCreateOpportunityProductItemSaga(),
    watchDeleteOpportunityProductItemSaga(),
  ]);
}
